
import React from "react";
import {getStudy} from "../components/results/components/variant-table/getAnnotations";
import {assignSettings} from "../../../../study-page/create-study/search-across-all/utils";


function getSamplesFromBucket(studySettings,studyBucket, analysis_id, samples_in_query){

    // get analysis samples;
    let study = getStudy(studySettings,studyBucket);
    let current_analysis = study.study.analyses.find(s => s.localId === analysis_id);
    let samples_to_analyze = current_analysis.samples;
    return assignSettings(samples_in_query, samples_to_analyze);

}

export {getSamplesFromBucket}

export const processParticipants = (patients, data, experimentGeneMap) => {
    const items = data?.["items"];
    if (!Array.isArray(patients?.["rows"])) return [];
    if (!Array.isArray(items)) return patients["rows"];

    return patients["rows"].map((par) => {
        const sampleList = items.filter((item) => item.Participant_ID === par.report_id);

        if (sampleList.length > 0) {
            const firstSample = sampleList[0];
            const experiments = sampleList.map((s) => s["ExperimentID"]).toString();
            par["ExperimentID"] = experiments;
            par["LocalExperimentID"] = firstSample["LocalExperimentID"];
            par["Owner"] = firstSample["Owner"];
            par["erns"] = firstSample["erns"];
            par["project"] = firstSample["project"];
            // n_genes from SNV experimentGeneMap when available; otherwise 0 (ParticipantTable fills from CNV aggregation when present)
            if (Array.isArray(experimentGeneMap) && experimentGeneMap.length > 0) {
                const geneData = experimentGeneMap.find((s) => s["experiment"] === firstSample["ExperimentID"]);
                par["n_genes"] = geneData ? geneData.genes.length : 0;
            } else {
                par["n_genes"] = 0;
            }
        }

        return par;
    });
};


export function extractGeneNames(jsonData) {
    /**
     * Extracts gene_name values from a JSON structure like the one provided.
     *
     * @param {object} jsonData - The JSON data object.
     * @returns {string[]} - A list of gene names.
     */
    const geneNames = [];


    let data = jsonData?.snv ?? null;
    if (data && data.hits && data.hits.hits) {
      data.hits.hits.forEach(hit => {
        if (hit.fields && hit.fields.effs) {
          hit.fields.effs.forEach(eff => {
            if (eff.gene_name) {
              geneNames.push(eff.gene_name);
            }
          });
        }
      });
    }
    return [...new Set(geneNames)];
  }